import React from 'react'

import { createRoot } from 'react-dom/client'

import App from './App'
import { diagnosticContext, diagnosticError, logDiagnostic } from './diagnostics'

diagnosticContext({ surface: 'outlook' })
logDiagnostic('outlook_taskpane_request_started')
window.addEventListener('error', (event) =>
    logDiagnostic(
        'outlook_runtime_request_failed',
        { ...diagnosticError(event.error), stage: 'window_error' },
        'ERROR',
    ),
)
window.addEventListener('unhandledrejection', (event) =>
    logDiagnostic(
        'outlook_runtime_request_failed',
        { ...diagnosticError(event.reason), stage: 'unhandled_rejection' },
        'ERROR',
    ),
)

const container = document.getElementById('root')

if (!container) {
    throw new Error('Taskpane root element was not found.')
}

createRoot(container, {
    onUncaughtError: (error) => logDiagnostic('outlook_render_request_failed', diagnosticError(error), 'ERROR'),
}).render(<App />)
